import { createStore } from 'services/Flux'
import Immutable from 'immutable';
import { actionsType } from 'config/constants'

const setItems = (state, action) => {
    if (!(action.payload && action.payload.orderForm && state)) {
        return {...state};
    }

    let newState = { ...state };

    const items = action.payload.orderForm.items ? action.payload.orderForm.items : [];

    let orderFormItems = Immutable.OrderedMap();

    items.map(item => {
        orderFormItems = orderFormItems.set(item.id, item);
    });

    newState.orderFormItems = orderFormItems;

    return newState;
}

const setCart = (state, action) => {
    if (!(action.payload && state)) {
        return state;
    }

    let newState = setItems(state, action);
    const items = newState.orderFormItems.toList().toArray();

    if(!(items && items.length > 0)) return state;

    newState.products = newState.products.map(products => {
        let newProducts = [];

        items.map(item => {
            newProducts = products.update(
                item.id,
                product => {
                    if (!product) return product;

                    product.item.quantity = item.quantity;
                    product.item.inCart = item.quantityTotal;
                    return product;
                },
            );
        });

        return newProducts;
    }).toOrderedMap();

    return newState;
}

const removeItemCart = (state, action) => {
    if (!(action.payload && state)) {
        return state;
    }

    let newState = setItems(state, action);
    const items = newState.orderFormItems;
    const {removeElement} = action.payload;

    newState.products = newState.products.map(products => {
        const newProducts = products.update(
            removeElement,
            product => {
                if (!product) return product;
                const item = items.get(removeElement);

                if(!item){
                    product.item.inCart = 0;
                    product.item.quantity = 0;
                } else {
                    product.item.quantity = item.quantity;
                    product.item.inCart = item.quantityTotal;
                }
                return product;
            },
        );

        return newProducts;
    }).toOrderedMap();

    return newState;
}

const clearCart = (state, action) => {
    if (!(action.payload && state)) {
        return state;
    }

    let newState = { ...state };

    newState.products = newState.products.map(products => {
        let newProducts = products;

        const ids = products.toList().toArray().map(product =>{
            if(product.item.inCart){
                return product.item.itemId;
            }

            return false;
        }).filter(Boolean);

        ids.map(id => {
            newProducts = newProducts.update(
                id,
                product => {
                    if (!product) return product;
                    product.item.inCart = 0;
                    product.item.quantity = 0;
                    return product;
                },
            );
        });

        return newProducts;
    }).toOrderedMap();

    newState.orderFormItems = newState.orderFormItems.clear();

    return newState;
}

const getProduct = (state, action) => {
    if (!action.payload) {
        return state;
    }

    let newState = { ...state };
    let products = Immutable.OrderedMap();

    action.payload.products.map(product => {
        if(!(product && product.items)) return false;
        const items = product.items;

        items.map(item => {
            const orderFormItem = newState.orderFormItems.get(item.itemId);

            product.item = item;

            if(orderFormItem){
                product.item.quantity = orderFormItem.quantity;
                product.item.inCart = orderFormItem.quantityTotal;
            }

            products = products.set(item.itemId, product);
        });
    });

    newState.products = state.products.set(action.payload.id, products);

    return  newState;
}

const Store = createStore((state, action) => {
    switch (action.type) {
        case actionsType.GET_PRODUCT:
            return getProduct(state, action);

        case actionsType.GET_PRODUCTS:
            return getProduct(state, action);

        case actionsType.GET_PRODUCTS_SKU:
            return getProduct(state, action);

        case actionsType.GET_SEARCH_PRODUCTS:
            return getProduct(state, action);

        case actionsType.GET_SHELF_PRODUCTS:
            return getProduct(state, action);

        case actionsType.ADD_ITEM_CART:
            return setCart(state, action);

        case actionsType.REMOVE_ITEM_CART:
            return removeItemCart(state, action);

        case actionsType.GET_CART:
            return setCart(state, action);

        case actionsType.UPDATE_CART:
            return setCart(state, action);

        case actionsType.CLEAR_CART:
            return clearCart(state, action);

        default:
            return state;
    }
}, {
    products: Immutable.OrderedMap(),
    orderFormItems: Immutable.OrderedMap()
});

export default Store;

